import axiosInstance from '@/services/axiosInstance'

async function getPricingAnalysis (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `pricingAnalysis/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

export { getPricingAnalysis }
